import { reportingDashboardConstants } from "../_constants";

const {
  GET_ALL_UPDATED_REPORTS_START,
  GET_ALL_UPDATED_REPORTS_SUCCESS,
  GET_ALL_UPDATED_REPORTS_FAILED,
  VIEW_UPDATED_REPORT_START,
  VIEW_UPDATED_REPORT_SUCCESS,
  VIEW_UPDATED_REPORT_FAILED,
} = reportingDashboardConstants;

const initialState = {
  updatedReports: [],
  isViewUpdatedReportLoading: false,
  viewUpdatedReportError: null,
  updatedReportCount: 0,
  isGetAllUpdatedReportsLoading: false,
  getAllUpdatedReportsError: null,
  currentUpdatedReport: null,
};

const UpdateReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_UPDATED_REPORTS_START:
      return {
        ...state,
        isGetAllUpdatedReportsLoading: true,
      };
    case GET_ALL_UPDATED_REPORTS_SUCCESS:
      const { content, count } = payload;
      return {
        ...state,
        isGetAllUpdatedReportsLoading: false,
        updatedReports: content,
        updatedReportsCount: count,
      };
    case GET_ALL_UPDATED_REPORTS_FAILED:
      return {
        ...state,
        isGetAllUpdatedReportsLoading: false,
        getAllUpdatedReportsError: payload,
      };
    case VIEW_UPDATED_REPORT_START:
      return {
        ...state,
        isViewUpdatedReportLoading: true,
        viewUpdatedReportError: null,
      };
    case VIEW_UPDATED_REPORT_SUCCESS:
      return {
        ...state,
        isViewUpdatedReportLoading: false,
        currentUpdatedReport: payload,
      };
    case VIEW_UPDATED_REPORT_FAILED:
      return {
        ...state,
        isViewUpdatedReportLoading: false,
        viewUpdatedReportError: payload,
      };
    default:
      return state;
  }
};

export default UpdateReportReducer;
